/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { PdfSection } from './pdf-section';
import { PdfUtils } from '../pdf-utils';
import { TranslateService } from '@ngx-translate/core';
import { PdfHeader } from '../pdf-header';

export class TitlePdfSection extends PdfSection {
  constructor(title: string) {
    super(title);
  }
  build(
    trl: TranslateService,
    doc,
    header: PdfHeader,
    x: number,
    y: number
  ): number {
    const text = trl.instant(this.title);
    const maxHeight = doc.internal.pageSize.getHeight() - 30;
    doc.setDrawColor(47, 55, 58);
    doc.setTextColor(47, 55, 58);
    doc.setFontSize(14);
    const dimension = doc.getTextDimensions(text);
    doc.setFont('roboto', 'bold');
    const x2 = doc.internal.pageSize.getWidth() - 30 - x;
    const newX = x + this.margin.w - 10;
    doc.text(newX, y + this.margin.h, text);
    doc.line(newX, y + dimension.h + 5, x2, y + dimension.h + 5);

    let newY = y + this.margin.h;
    newY = newY + PdfUtils.getMinHeight(doc, text, x2 - 30) - 25;
    if (newY > maxHeight) {
      PdfUtils.addPage(doc, header);
      y = header.height;
      newY = y + this.margin.h;
    }
    return newY;
  }

  getDimension(doc: unknown): { w: number; h: number } {
    void doc;
    return { h: 0, w: 0 };
  }
}
